<template>
  <div class="new-bank-account-view">
    <div class="d-flex justify-content-between align-items-center mb-5">
      <h5 class="text-semibold pb-5">Nova Conta Bancária</h5>
      <div class="d-flex justify-content-between align-items-center gap-4">
        <snow-button
          text="Cancelar"
          variant="gray"
          @click="$router.push({ name: 'user-financial-data' })"
        />
        <snow-button :disabled="!isValid" text="Salvar" @click="submit" />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="w-100 bg-2 rounded-16 p-5">
          <select-person-type v-model="form.type" />
          <snow-select
            v-model="form.bank_id"
            required
            class="my-4"
            label="Banco"
            :options="banksOptions"
            :rules="[rules.required]"
          />
          <div class="d-flex gap-3 w-100 mb-4">
            <snow-input
              v-model="form.agency"
              required
              class="w-100"
              label="Agência *"
              placeholder="0000"
              :rules="[rules.required]"
            />
            <snow-input
              v-model="form.agency_vd"
              mask="#"
              label="Dígito"
              placeholder="0"
              class="w-100"
            />
          </div>
          <div class="d-flex gap-3 w-100 mb-4">
            <snow-input
              v-model="form.number_account"
              required
              label="Conta *"
              class="w-100"
              placeholder="0000000"
              :rules="[rules.required]"
            />
            <snow-input
              v-model="form.number_account_vd"
              mask="#"
              label="Dígito"
              class="w-100"
              placeholder="0"
            />
          </div>
          <div class="d-flex gap-3 w-100 mb-4">
            <snow-input
              v-model="form.owner_account"
              required
              label="Titular da conta *"
              placeholder="Ex. Seu Nome"
              class="w-100"
              :rules="[rules.required]"
            />
            <snow-input
              v-if="form.type == 'PF'"
              v-model="form.document"
              required
              label="CPF *"
              class="w-100"
              mask="###.###.###-##"
              placeholder="000.000.000-00"
              :errors="errors.document"
              :rules="[rules.required, rules.isValidCPF]"
            />
            <snow-input
              v-else
              required
              label="CNPJ *"
              class="w-100"
              v-model="form.document"
              mask="##.###.###/####-##"
              placeholder="00.000.000/0000-00"
              :errors="errors.document"
              :rules="[rules.required, rules.isValidCNPJ]"
            />
          </div>
          <snow-select
            v-model="form.type_account"
            class="mb-5"
            label="Tipo de conta *"
            :options="[
              { id: 1, name: 'Conta Corrente' },
              { id: 2, name: 'Conta Poupança' }
            ]"
            :errors="errors.type_account"
          />
          <snow-input-file
            v-model="form.document_file"
            type="File"
            maxSize=""
            isDocument
            title="Comprovante do seu CPF/CNPJ"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SnowInput from "@/components/snow-ui/form/SnowInput.vue";
import SelectPersonType from "@/components/user/PersonalData/SelectPersonType";
import { formFields, isValidCNPJ, isValidCPF } from "@/functions/helpers";
import { required } from "@/functions/validation";
import { mapState } from "vuex";
export default {
  components: { SnowInput, SelectPersonType },
  data() {
    return {
      ...formFields(
        [
          "document_file",
          "type",
          "bank_id",
          "agency",
          "agency_vd",
          "number_account",
          "number_account_vd",
          "owner_account",
          "document",
          "type_account"
        ],
        { type: "PF", bank_id: 1 }
      ),
      loading: false,
      isMobile: window.innerWidth < 992,
      rules: {
        required: required(),
        isValidCNPJ: val => isValidCNPJ(val) || "CNPJ inválido",
        isValidCPF: val => isValidCPF(val) || "CPF inválido"
      }
    };
  },
  computed: {
    ...mapState("financial", ["banksList"]),
    documentType() {
      return this.form.type == "pf" ? "CPF" : "CNPJ";
    },
    banksOptions() {
      return this.banksList.map(item => {
        return {
          id: item.id,
          name: `${item.compe} - ${item.long_name}`
        };
      });
    },
    isValid() {
      if (!this.form.document) return false;
      if (this.loading) return false;

      if (
        (this.form.type == "PJ" && !isValidCNPJ(this.form.document)) ||
        (this.form.type == "PF" && !isValidCPF(this.form.document))
      )
        return false;

      return !!(
        this.form.document_file &&
        this.form.type &&
        this.form.bank_id &&
        this.form.agency &&
        this.form.number_account &&
        this.form.owner_account &&
        this.form.document &&
        this.form.type_account
      );
    }
  },
  methods: {
    submit() {
      const data = { ...this.form };
      data.agency_vd = data.agency_vd || 0;
      data.number_account_vd = data.number_account_vd || 0;
      data.type = data.type.toLowerCase();

      this.loading = true;
      this.$store
        .dispatch("financial/postBankAccount", data)
        .then(() => {
          this.$router.push({ name: "user-financial-data" });
        })
        .catch(() => {
          this.$message.error("Erro ao cadastrar conta bancária");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    this.$store.dispatch("financial/getBanksList");
  },
  watch: {
    "form.type"() {
      this.form.document = "";
    }
  }
};
</script>
